import React, { useEffect, useState } from "react";

import { CircularProgress, Button, Dialog, IconButton } from "@mui/material";

import { Formik, Form } from "formik";
import * as yup from "yup";

import Steper from "../../MUI_components/stepper";
import ItemMaster from "../../../Service/Item-master/itemMaster.service";
import Dialogg from "../../MUI_components/Dialog-Box/dialog";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { fetchItemCategory } from "../../../Redux/Actions/itemCategoryActions";
import { fetchSubCategory } from "../../../Redux/Actions/itemCategoryActions";
import { fetchUnit } from "../../../Redux/Actions/unitActions";
import { fetchColour } from "../../../Redux/Actions/colourActions";
import { fetchBrand } from "../../../Redux/Actions/brandActions";
import { fetchBin } from "../../../Redux/Actions/binActions";
import {fetchSize} from "../../../Redux/Actions/sizeActions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../MUI_components/loading";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import itemSubCategoryService from "../../../Service/Item-master/itemSubCategory.service";
import AddCategory from "../Category/addCategory";
import Dropzone from 'react-dropzone';
import { AddCircle } from "@mui/icons-material";


const AddItemMaster = (props) => {
  const dispatch = useDispatch();

  const itemCategory = useSelector((state) => state.itemCategory.rows);
  // const subCategory = useSelector((state) => state.subCategory.rows);
  const itemColour = useSelector((state) => state.colour.rows);
  const itemUnit = useSelector((state) => state.unit.rows);
  const itemBin = useSelector((state) => state.bin.rows);
  const brand = useSelector((state) => state.brand.rows);
  const itemSize = useSelector((state) => state.size.rows);


  const [isLoaded, setIsLoaded] = useState(false);
  const [initValue, setInitValue] = useState([]);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [categoryTransactionCode,setCategoryTransactionCode] = useState(null);
  const [categoryCode,setCategoryCode] = useState(null);
  const [barcodeLoading,setBarcodelaoding] = useState(false);
  const [categoryName,setCategoryName] = useState("");
  const [brandName,setBrandName] = useState("")
  const [subcategoryname,setSubcategoryName] = useState("")
  const [colour,setColour] = useState("");
  const [size,setSize] = useState("");
  const [childUpdate, setChildUpdate] = useState(false);

  const { code, setOpen, setSubmitted, setSubmittedd, stock } = props;
  const [subCategory, setSubCategory] = useState([]);
  const [images, setImages] = useState({
    image: null,
  });
   const [openn, setOpenn] = useState(false);
   const [formSubmitted, setFromSubmitted] = useState(false);

     const handleClickOpen = () => {
    setOpenn(true);
  };

  const RadioOptions = [

    {
      label: "Product",
      value: "product",
      checked: true,
    },
    {
      label: "Service",
      value: "service",
      checked: false,
    },
    {
      label: "Raw Material",
      value: "rawMaterial",
      checked: false,
    },
    {
      label: "Asset",
      value: "asset",
      checked: false,
    },
  ];

  useEffect(() => {
    const getSubCategory = async () => {
      try {
        const subcat = await itemSubCategoryService.getAll();
        setSubCategory(subcat);
      } catch (e) {
        dispatch(openSnackbar(true, "error", e.message));
      }
    };
    const getItemMaster = async () => {
      if (code) {
        try {
          let response = await ItemMaster.get(code);
          // converting NULL value into Empty string
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
            
          );
          setInitValue({
            ...response,
            type:response.itemTypeLabel,
            // itemType: 
          });
          setCategoryTransactionCode(response.itemCategory?.code);
          setCategoryCode(response.itemCategory?.categoryCode);
          setCategoryName(response.itemCategory?.name);
          setCategoryName(response.itemCategory?.name);
          setSubcategoryName(response.itemSubCategory?.name);
          setBrandName(response.itemBrand?.name);
          setColour(response.itemColor?.name);
        } catch (e) {
          dispatch(openSnackbar(true, "error", e.message));
        }
      } else {
        setInitValue({
          barcode: null,
          name: "",
          description: "",
          sku: "",
          size: "",
          type: "product",
          itemCategory: "",
          itemSubCategories: null,
          itemUnit: "",
          itemBrand: null,
          itemColor: null,
          itemBinLocation: null,
          wholesalePrice: "",
          retailPrice: "",
          dealerPrice: "",
          leastPrice: "",
          costPrice: "",
          minStock: "",
          maxStock: "",
          isActive: "",
          expiryNotificationDays: "",
          discountAmount:0,
          discountPercentage:0,
        });
      }
      setIsLoaded(true);
    };
    getSubCategory();
    getItemMaster();
    dispatch(fetchItemCategory());
    dispatch(fetchSubCategory());
    dispatch(fetchBrand());
    dispatch(fetchColour());
    dispatch(fetchUnit());
    dispatch(fetchBin());
    dispatch(fetchSize());
  }, [code, dispatch, childUpdate]);

  const [activeStep, setActiveStep] = React.useState(0);

  // validation Schema for first step
  const Validation = yup.object({
    barcode: yup.string().required().nullable(),
    itemUnit: yup.object().when("type", {
      is: 'product',
      then: yup.object().required(),
    }),
    itemCategory: yup.object().required().nullable(),
    name: yup.string().required(),
    minStock: yup
      .number()
        .nullable()
        .when("type", {
          is: "product",
          then: (schema) =>
            schema
              .required("Minimum Stock is required")
              .integer("Minimum Stock must be an integer")
              .moreThan(0, "Minimum Stock must be greater than 0"),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),

    maxStock: yup
        .number()
        .nullable()
        .when("type", {
          is: "product",
          then: (schema) =>
            schema
              .required("Maximum Stock is required")
              .integer("Maximum Stock must be an integer")
              .moreThan(0, "Maximum Stock must be greater than 0"),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),
    });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getSteps = ["Item Information", "Price and Discounts"];

  const [clickSave, setClickSave] = useState(false);


  const handleSubmit = async (values) => {
    setClickSave(true);
    try {
      const formData = new FormData();
       formData.append('image', uploadedImage);

      if (code) await ItemMaster.edit(values, code);
       else {
        const res = await ItemMaster.create(values);
        setSubmittedd?.({
          ...stock,
          itemMaster: res.savedItemMaster,
          costPrice: res.savedItemMaster.costPrice,
          retailPrice: res.savedItemMaster.retailPrice,
          wholesalePrice: res.savedItemMaster.wholesalePrice,
        });

        if(res.itemExistingExiting) {
          alert(res.message);
          return
        }}
      
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Item ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
        const message =
          e?.response?.data?.message || // Axios / API error
          e?.message ||                 // Normal JS error
          "Something went wrong";

        dispatch(openSnackbar(true, "error", message));
    }
    setClickSave(false);
  };

  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
            } else handleNext();
          }}
        >
          {(props) => (
            <Form autoComplete="off">
              <Steper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
                setFieldValue={props.setFieldValue}
                values={props.values}
              />
              <div className="row space-between mb">
                <Button
                  disabled={activeStep === 0 || props.isValid === false}
                  onClick={handleBack}
                >
                  Back
                </Button>

                <div style={{ display: "flex" }}>
                  {code && activeStep !== getSteps.length - 1 && (
                    <Button
                      disabled={clickSave ? true : false}
                      startIcon={
                        clickSave && (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      onClick={() => {
                        handleSubmit(props.values);
                      }}
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 5 }}
                    >
                      {clickSave ? "Saving" : "Save"}
                    </Button>
                  )}
                  <Button
                    disabled={props.isSubmitting ? true : false}
                    startIcon={
                      props.isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );

  function getStepContent(step, values, setFieldValue) {
    switch (step) {
      case 0:
        return (
          <>
            <div className="row">
              <div className="col-5">
                <FormControl control="input" name="name" label="Item Name" />
                <Button

                onClick={() => {
                  let description = "";
                  // Concatenate non-empty values with space, trimming each part
                  if (categoryName && categoryName.trim() !== "")
                      description += categoryName.trim();
                  if (subcategoryname && subcategoryname?.trim() !== "")
                      description += " " + subcategoryname.trim();
                  if (brandName && brandName.trim() !== "")
                      description += " " + brandName.trim();
                  if (size && size.trim() !== "")
                      description += " " + size.trim();
                  if ( colour && colour?.trim() !== "")
                      description += " " + colour.trim();                
                   setFieldValue("name", description);
                }}

                 variant="contained"
                 color="primary"
                >Generate Description</Button>
              </div>
              <div className="col-1">
                 <IconButton color="primary" onClick={handleClickOpen}>
                          <AddCircle sx={{ fontSize: 40 }}/>
                              </IconButton>
                              <Dialogg
                                maxWidth={"md"}
                                open={openn}
                                setOpen={setOpenn}
                                title={`Add Category`}
                              >
                                <AddCategory
                                  setChildUpdate={setChildUpdate}
                                  setSubmitted={setFromSubmitted}
                                  setOpen={setOpenn}
                                  fetchItemCategory={fetchItemCategory}
                                  // {...rest}
                                />
                              </Dialogg>
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  label="Category"
                  name="itemCategory"
                  options={itemCategory}
                  onChange={(event, newValue) => {
                    setFieldValue("itemCategory", newValue);
                    setFieldValue("itemSubCategories", null);
                    setCategoryTransactionCode(newValue?.code);
                    setCategoryCode(newValue?.categoryCode);
                    setCategoryName(newValue?.name)
                    
                  }}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="input"
                  name="barcode"
                  label="Barcode (Max 1000 Item Per Cat)"
                  />
                 <Button
              className="generateBarcode"
              onClick={async () => { // Mark the function as async
                setBarcodelaoding(true);
                try {
                  let currentBarcode; 
                  if(!categoryTransactionCode) {
                    alert("Please select category")
                    setBarcodelaoding(false);
                    return
                  }
                    const res = await ItemMaster.getLastBarcode(categoryTransactionCode);
                  if(res.item.length == 0) {
                    currentBarcode = categoryCode + "001"
                    setFieldValue("barcode", currentBarcode.toString());
                    setBarcodelaoding(false);
                    return
                  }
                    let lastBarcodeSuffix = parseInt(res.item[0].barcode.slice(-3));
                    //setExistingCode(res.item[0].barcode.slice(0,-2)); 
                    lastBarcodeSuffix++;
                    let paddedSuffix = lastBarcodeSuffix.toString().padStart(3, '0');
                    currentBarcode = categoryCode + paddedSuffix;
                    setFieldValue("barcode", currentBarcode.toString());
                } catch (e) {
                    dispatch(openSnackbar(true, "error", e));
                }
                setBarcodelaoding(false);

            }}
              startIcon={
                  barcodeLoading && (
                      <CircularProgress color="inherit" size={20} />
                  )
              }
              variant="contained"
              color="primary"
          >
              Generate Barcode
          </Button>


              </div>
            </div>
            {values.type === "service" && (
              <div className="row">
                <div className="col-12">
                  <FormControl
                    control="input"
                    label="Description"
                    name="description"
                  />
                </div>
              </div>
            )}

            <div className="row">
          
                  <div className="col-12">
                    <FormControl
                      control="radio"
                      label="Product | Service | Raw Material"
                      options={RadioOptions}
                      name="type"
                    />
                  </div>
            </div>
            {values.type !== "service" && (
              <>
                <div className="row">
                  <div className="col-4">
                    <FormControl
                      control="number"
                      name="minStock"
                      label="Minimum Stock"
                    />
                  </div>

                  <div className="col-4">
                    <FormControl
                      control="number"
                      name="maxStock"
                      label="Maximum Stock"
                    />
                  </div>

                  <div className="col-4">
                    <FormControl
                      control="autoComplete"
                      label="Sub-category"
                      name="itemSubCategories"
                      options={
                        values.itemCategory
                          ? subCategory.filter(
                            (category) =>
                              category.categoryCode ===
                              values.itemCategory.code
                          )
                          : []
                      }

                      onChange={(event, newValue) => {
                        setFieldValue("itemSubCategories", newValue);
                        setSubcategoryName(newValue?.name) 
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <FormControl 
                    control="autoComplete"                    
                    label="Size" 
                    name="size" 
                    options={itemSize}
                    onChange={(event, newValue) => {
                      setFieldValue("size", newValue);
                      setSize(newValue?.name)
                    }}

                    />
                  </div>
                  <div className="col-3">
                    <FormControl
                      control="autoComplete"
                      label="Unit"
                      options={itemUnit}
                      name="itemUnit"
                    />
                  </div>
                  <div className="col-3">
                    <FormControl
                      control="autoComplete"
                      label="Colour"
                      options={itemColour}
                      name="itemColor"
                      onChange={(event, newValue) => {
                        setFieldValue("itemColor", newValue);
                        setColour(newValue?.name)
                        
                        
                      }}
                      
                    />
                  </div>
                  <div className="col-3">
                    <FormControl
                      control="autoComplete"
                      label="Brand"
                      name="itemBrand"
                      options={brand}
                      onChange={(event, newValue) => {
                        setFieldValue("itemBrand", newValue);
                        setBrandName(newValue?.name)
                        
                      }}
                    />   
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <FormControl
                      control="autoComplete"
                      label="Bin Location"
                      options={itemBin}
                      name="itemBinLocation"
                      getOptionLabel={(option) => option.location}
                    />
                  </div>
                  <div className="col-2">
                    <FormControl
                      control="input"
                      label="SKU"
                      name="sku"
                    />
                  </div>
                  <div className="col-7">
                    <FormControl
                      control="input"
                      label="Description"
                      name="description"
                    />
                  </div>
                </div>
                <div className="row">
                  <div>
                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      const [file] = acceptedFiles; // Take only the first file if multiple files are dropped
                      setUploadedImage(file);
                      setFieldValue("image", file);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()} className="dropzone">
                        <input {...getInputProps()} />
                        <Button >Select Image</Button>
                      </div>
                    )}
                  </Dropzone>
                  {uploadedImage && (
                    <img
                      src={URL.createObjectURL(uploadedImage)}
                      alt={`uploaded-image`}
                      style={{ width: '100px', height: '100px', alignContent: 'left' }}
                    />
                  )}
                  </div>
                 
                </div>
              </>
            )}
            <div className="row">
              {code && (
                <FormControl control="switch" label="Active" name="isActive" />
              )}
            </div>
          </>
        );
      
        case 1:
          return (
            <>
              {values.type !== "service" && (
                <div className="row">
                  <div className="col-4">
                    <FormControl
                      control="currency"
                      label="Cost Price"
                      name="costPrice"
                    />
                  </div>
                  {/* <div className="col-4">
                    <FormControl
                      control="currency"
                      label="Dealer Price"
                      name="dealerPrice"
                    />
                  </div> */}
                  <div className="col-4">
                    <FormControl
                      control="currency"
                      label="Wholesale Price"
                      name="wholesalePrice"
                    />
                  </div>
                 <div className="col-4">
                  <FormControl
                    control="currency"
                    label={values.type !== "service" ? `Retail Price` : `Price`}
                    name="retailPrice"
                  />
                </div>
                </div>
              )}
              
              <div className="row">
                {values.type == "service" && (
                  <div className="col-4">
                      <FormControl
                        control="currency"
                        label={values.type !== "service" ? `Retail Price` : `Price`}
                        name="retailPrice"
                      />
                    </div>
                )}
                <div className="col-4">
                  <FormControl
                    control="currency"
                    label="Invoice Discount Rs"
                    name="discountAmount"
                  />
                </div>
                <div className="col-4">
                  <FormControl
                    control="input"
                    label="Invoice Discount %"
                    name="discountPercentage"
                  />
                </div>
                {values.type !== "service" && (
                  <div className="col-4">
                    <FormControl
                      control="number"
                      label="Expiry notify days"
                      name="expiryNotificationDays"
                    />
                  </div>
                )}
              </div>
            </>
          );

      default:
        return null;
    }
  }
};

export default AddItemMaster;